export default __webpack_public_path__ + "static/media/mokhaberat.fbaa7544.png";